import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

type FieldType =
  | 'input'
  | 'dropdown'
  | 'calendar'
  | 'radio'
  | 'checkbox'
  | 'checkbox-binary'
  | 'multiselect'
  | 'autocomplete'
  | 'selectbutton'
  | 'textarea';

type InputType =
  | 'button'
  | 'checkbox'
  | 'color'
  | 'date'
  | 'datetime-local'
  | 'email'
  | 'file'
  | 'hidden'
  | 'image'
  | 'month'
  | 'number'
  | 'password'
  | 'radio'
  | 'range'
  | 'reset'
  | 'search'
  | 'submit'
  | 'tel'
  | 'text'
  | 'time'
  | 'url'
  | 'week';

type InputMode = 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url' | 'currency';

export type FormFieldOption = {
  label: string;
  value: any;
};

export interface PasswordRequirements {
  atLeastEightCharacters: boolean | null;
  containsLowercase: boolean | null;
  containsUppercase: boolean | null;
  containsNumber: boolean | null;
  containsSymbol: boolean | null;
}

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent implements OnInit {
  @Input() control!: FormControl;
  @Input() label?: string;
  @Input() boldLabel?: boolean;
  @Input() errorLabel?: string;
  @Input() labelHint?: string;
  @Input() name!: string;
  @Input() type?: FieldType;
  @Input() limitWidth: boolean = false;
  @Input() inputType: InputType = 'text';
  @Input() inputMode: InputMode = 'text';
  @Input() inputMask?: string;
  @Input() placeholder: string = '';
  @Input() options: FormFieldOption[] = [];
  @Input() noMargin: boolean = false;
  @Input() leftImageUrl?: string | null;
  @Input() rightImageUrl?: string | null;
  @Input() min?: number;
  @Input() horizontalLayout: boolean = false; // TODO Applies only to radios; apply to checkboxes
  @Input() small: boolean = false; // TODO Applies only to checkboxes; apply to other elements
  @Input() toggleShowPassword: boolean = true;
  @Input() showNotMatchError: boolean = false;
  @Input() tooltip: string = ''; // TODO Applies only to number and text input; apply to others
  @Input() noCheckboxMargin: boolean = false;
  @Input() completeMethod: (event: any) => any = () => {}; // only used in autocomplete
  @Input() isLoading: boolean = false; // only used in autocomplete
  @Input() characterLimit?: number;
  @Input() characterCount?: number;

  isRequired: boolean = false;

  passwordValue: string = '';

  constructor() {}

  ngOnInit() {
    this.isRequired =
      this.control.hasValidator(Validators.required) || this.control.hasValidator(Validators.requiredTrue);
  }

  public onNumberInput = (e: { originalEvent: KeyboardEvent; value: any }): void => {
    // primeng doesn't respect the updateOn setting of the control and defaults to onBlur
    // hooking this event and setting the value if updateOn is 'change' which is the default for Reactive Forms

    // https://github.com/primefaces/primeng/issues/9132
    // https://github.com/primefaces/primeng/issues/10283

    // This is the proposed fix proposed here (we did not see a need for Safari fixes):
    // https://github.com/primefaces/primeng/issues/9132#issuecomment-1230520899

    if (!this.control.disabled) {
      if (!this.control?.updateOn || this.control?.updateOn === 'change') {
        this.control.setValue(e.value);
      }
    }
  };
}
